<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="$emit('close')">
      <div class="howto guide" role="dialog" aria-modal="true" aria-label="What the words mean">
        <button class="howto__close icon-button" aria-label="Close" @click="$emit('close')">×</button>
        <div class="howto__body">
          <h3>What the words mean</h3>
          <!--
            The legend. Every glyph on a card, a price tag and the top strip
            is in here beside the word for it, so the little pips are
            learnable rather than guessable.
          -->
          <ul class="glossary glossary--dialog">
            <li v-for="g in GLOSSARY" :key="g.term">
              <span v-if="g.icon" class="glossary__icon"><Pip :kind="g.icon" :n="1" /></span>
              <strong>{{ g.term }}</strong> {{ g.text }}
            </li>
          </ul>
        </div>
        <div class="howto__nav">
          <span class="howto__dots" />
          <button class="primary howto__next" @click="$emit('close')">Got it</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { GLOSSARY } from '@/glossary';
import Pip from '@/components/game/Pip.vue';

export default {
  name: 'Glossary',
  components: { Pip },
  emits: ['close'],
  data() { return { GLOSSARY }; },
};
</script>
